import CategoryPage from "./CategoryPage";
const HERO = "https://images.pexels.com/photos/31817160/pexels-photo-31817160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=2000";
export default function Vente() {
  return <CategoryPage category="sale" heroImage={HERO} titleKey="sale" />;
}
